import type { UserData } from '@api/utils/sequelize/calculateUserData';
import type { GetEstimateDetailsResponse } from '@api/features/estimates/getEstimateDetails';

const getRelevantCargoTypes = (
	userData: UserData | undefined,
	estimate: GetEstimateDetailsResponse | null,
) => {
	if (userData == null) {
		return [];
	}

	const vesselType = estimate?.vessel?.type;

	return userData.cargoTypes
		.filter((cargoType) => (
			cargoType.active &&
			(
				vesselType == null ||
				cargoType.vesselTypes?.includes(vesselType)
			)
		))
		.sort((a, b) => a.name.localeCompare(b.name));
};

export default getRelevantCargoTypes;